import { html, LitElement, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

import styles from "./image-slide.css";

import type { DiagramVisualData, ImageVisualData } from "../../types.d";
import type { SlideViewMode } from "../slide/slide";

@customElement("bp-image-slide")
export class ImageSlide extends LitElement {
  static styles = styles;

  @property()
  data?: DiagramVisualData | ImageVisualData;

  @property({ attribute: "title" })
  slideTitle?: string;

  @property({ attribute: "view-mode" })
  viewMode?: SlideViewMode = "default";

  render() {
    if (!this.data) return;

    const { src, alt } = this.data;

    return html`
      <div class="image-slide ${this.viewMode}">
        ${this.slideTitle
          ? html`<div class="title">${unsafeHTML(this.slideTitle)}</div>`
          : nothing}
        <div class="image-container">
          <img src=${src} alt=${alt} title=${alt} />
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-image-slide": ImageSlide;
  }
}
